module.exports = __webpack_public_path__ + "img/normal_multiplier_2.6fdae811.png";